import { useEffect } from 'react';
import { MutationState } from 'hooks/useMutation';

interface HandleMutationProps {
  data?: any;
  error?: any;
  status?: string;
  isSuccess?: boolean;
  isError?: boolean;
  onSuccess?: (data?: any) => void;
  onError?: (error: any) => void;
  reset?: MutationState<any>['reset'];
}

export const useMutationHandler = ({
  data,
  error,
  status,
  isSuccess,
  isError,
  onError,
  onSuccess,
  reset,
}: HandleMutationProps) => {
  useEffect(() => {
    if (error || isError) {
      onError?.(error);
    }
  }, [error, isError, onError]);

  useEffect(() => {
    if ((status === 'fulfilled' || isSuccess) && onSuccess) {
      onSuccess(data);
      reset?.();
    }
  }, [status, isSuccess, data, onSuccess, reset]);
};

/** @deprecated use useMutationHandler */
export const handleMutation = useMutationHandler;
